import { SURVEY_TESTS_LIST } from "./types";
import firebase from "../firebase";

export const surveyTestsDisplay = params => {
  if (params.type === SURVEY_TESTS_LIST) {
    
    return (dispatch, getState) => {
    

    //  firebase.database.ref(`surveyAnalytics/${params.companyID}/${params.companyID}+'-'+${params.surveyid}`).on("value", function(data) {
   // firebase.database.ref('surveysTests/' + params.companyID + '/' + params.groupID + '/'+ params.surveyid + '/' + params.personid + '/').on("value", function(data) {
    const refPrimary = firebase.database.ref('surveysTests/' + params.companyID + '/' + params.surveyid + '/');
    const refFallback = params.groupID
      ? firebase.database.ref('surveysTests/' + params.companyID + '/' + params.groupID + '/' + params.surveyid + '/')
      : null;

    let primaryData = {};
    let fallbackData = {};

    const emit = () => {
      const merged = { ...(primaryData || {}), ...(fallbackData || {}) };
      if (merged && Object.keys(merged).length > 0) {
        dispatch({
          type: SURVEY_TESTS_LIST,
          tests_list: merged
        });
      } else {
        dispatch({
          type: SURVEY_TESTS_LIST,
          tests_list: {}
        });
      }
    };

    refPrimary.on("value", function(data) {

    
    
    

    //updates['surveysTests/' + params.companyID + '/' + params.groupID + '/'+ params.surveyid + '/' + params.personid + '/' + 'surveyname'] = params.surveyTitle;       
    // updates['surveysTests/' + params.companyID + '/' + params.groupID + '/'+ params.surveyid + '/' + params.personid + '/' + 'person'] = params.personid;       
    // updates['surveysTests/' + params.companyID + '/' + params.groupID + '/'+ params.surveyid + '/' + params.personid + '/' + 'testscore'] = params.counterCorrectAnswers;       

    if (data.val()) {     
          primaryData = data.val() || {};
          emit();
    
        } else {
          primaryData = {};
          emit();
        }
      });

    if (refFallback) {
      refFallback.on("value", function(data) {
        
        
        fallbackData = data.val() || {};
        emit();
      });
    }
      
   }
 }
};
